import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Routes/HomePage/HomePage";
import Schedule from "./Routes/Schedule/Schedule";
import Plan from "./Routes/Plan/Plan";
import NotFound from "./Routes/NotFound/NotFound";
import UnMountedComponent from "./Routes/UnMountedComponent/UnMountedComponent";

import GlassyNavbar from "./Components/Navbar/GlassyNavbar";
import Footer from "./Components/Footer/Footer";
import PlanWelcome from "./Components/Planner/PlanWelcome";
import PlanIntro from "./Components/Planner/PlanIntro";
import Stage1 from "./Components/Planner/Stage1";
import Stage2 from "./Components/Planner/Stage2";
import Stage3 from "./Components/Planner/Stage3";
import hideScrollbar from "./utlsComponent/ScrollbarController/HideScrollbar";
import showScrollbar from "./utlsComponent/ScrollbarController/ShowScrollbar";

import "./Global.css";

import { useEffect } from "react";
const AppRouter = () => {
  useEffect(() => {
    hideScrollbar(); // Hide when component mounts
    return () => {
      showScrollbar(); // Restore when component unmounts
    };
  }, []);

  return (
    <Router>
      <GlassyNavbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/planner" element={<Plan />}>
          <Route index element={<PlanWelcome />} />
          <Route path="onGrid">
            <Route index element={<PlanIntro />} />
            <Route path="stage1" element={<Stage1 />} />
            <Route path="stage2" element={<Stage2 />} />
            <Route path="stage3" element={<Stage3 />} />
            
          </Route>
          <Route path="offGrid">
            <Route index element={<PlanIntro />} />
            <Route path="stage1" element={<Stage1 />} />
            <Route path="stage2" element={<Stage2 />} />
            <Route path="stage3" element={<Stage3 />} />
            
          </Route>
        </Route>

        <Route path="/unmounted-components" element={<UnMountedComponent />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default AppRouter;
